import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { megacardApi, StoreResponses } from '@/stores/api';
import { AddressDto, MegacardRequestDto } from '@/api';
import { StoreResponse } from '@/stores/response';
import ErrorKey from '@/util/ErrorKey';

@Module({
  namespaced: true,
  name: 'MegacardStore',
})
export default class MegacardStore extends VuexModule {
  private storeRequestedMegacard: MegacardRequestDto | null = null;

  get requestedMegacard(): MegacardRequestDto | null {
    return this.storeRequestedMegacard;
  }

  get hasMegacardRequest(): boolean {
    return this.storeRequestedMegacard !== null;
  }

  @Mutation
  public resetRequestedMegacard() {
    this.storeRequestedMegacard = null;
  }

  @Action
  public async previewMegacardData(request: MegacardRequestDto): Promise<StoreResponse<AddressDto>> {
    try {
      const response = await megacardApi.previewMegacardData(request);
      this.context.commit('setRequestedMegacard', request);
      return StoreResponses.apiSuccess(response);
    } catch (e) {
      return StoreResponses.suppressedError(e, ErrorKey.MegacardImportException);
    }
  }

  @Action
  public async connectRequestedMegacard(): Promise<StoreResponse<null>> {
    const request = this.requestedMegacard;
    if (!request) {
      return StoreResponses.error(null, ErrorKey.NoMegacardSelected);
    }
    try {
      const response = await megacardApi.connectMegacard(request);
      this.context.commit('resetRequestedMegacard');
      return StoreResponses.success(null);
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.MegacardImportException);
    }
  }

  @Mutation
  private setRequestedMegacard(request: MegacardRequestDto) {
    this.storeRequestedMegacard = request;
  }
}
